import { type DateFormat, formatDate } from "../utils/dateTime.ts";
export default class DateModel {
  _data: Date;
  constructor(str: string) {
    this._data = new Date(str);
  }

  static today(): DateModel {
    return new DateModel(formatDate(new Date(), "YYYY-MM-DD"));
  }
  format(format: DateFormat): string {
    return formatDate(this._data, format);
  }

  asDate() {
    return this._data;
  }
}
